import * as React from 'react';
import styled from 'styled-components';
import { __ } from 'react-i18n';

interface Props {
  inputValue: string;
  handleInputValue: (data: string) => void;
  imageUrl?: string;
  imageSize?: string;
  isLeft?: boolean;
}

export class SearchInput extends React.Component<Props, {}> {
  handleChange = e => {
    this.props.handleInputValue(e.target.value);
  };
  render() {
    const { inputValue } = this.props;
    return (
      <SearchInputComponent
        isLeft={this.props.isLeft}
        imageSize={this.props.imageSize}
        placeholder={__('Vyhľadávanie')}
        value={inputValue}
        onChange={this.handleChange}
      />
    );
  }
}

const SearchInputComponent: any = styled.input`
  width: 100%;
  height: 100%;
  padding: 10px;
  padding-right: 15%;
  font-size: 14px;
  background-image: url('${(prop: any) => prop.imageUrl}');
  background-repeat: no-repeat;
  background-color: ${({ theme }) => theme.primary};
  background-size: ${(prop: any) => prop.imageSize || '5vh'};
  background-position: ${(props: any) =>
    props.isLeft === true ? '10px 50%' : 'calc(100% - 10px) 50%'};

    ${(props: any) => {
      if (props.isLeft === true) {
        return `
          padding-left: calc(25px + ${props.imageSize || '5vh'});
        `;
      }

      return ``;
    }}
  border-radius: ${({ theme }) => theme.borderRadius};
  border: 1px solid ${({ theme }) => theme.inactiveFontColor};
  color: ${({ theme }) => theme.primaryFontColor};

  &:focus {
    outline: none;
  }

  &::placeholder {
    font-size: 14px;
    color: ${({ theme }) => theme.inactiveFontColor};
  }
`;
